import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import { Gear } from '../../icons';
import Text from '../Text';
import Box from '../Box';

const Button = styled.button<{ side: string, bottom: string }>`
  background-color: #fff;
  height: 35px;
  position: fixed;
  ${(props) => props.side}: 10px;
  bottom: ${(props) => props.bottom};
  border: 1px solid #cccccc;
  padding: 5px 8px;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, .15);
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
  z-index: 99999;
`;

const Portal: React.FC = ({ children }) => (
  ReactDOM.createPortal(children, document.body)
);

const ENV_LIST = ['dev', 'testing', 'staging'];
const COOKIE_NAME = 'build_env';

type Props = {
  side?: 'left' | 'right';
  bottom?: string;
}
// Wanted this whole component to be agnostic of all packages
// other than styled components since we use that package everywhere
const EnvironmentSwitcher: React.FC<Props> = (props: Props) => {
  const { side, bottom } = props;

  const currentEnv = document?.cookie?.split('; ')?.find(
    (cookie) => cookie.includes(COOKIE_NAME) && ENV_LIST.includes(cookie.split('=')[1]),
  )?.split('=')[1] || ENV_LIST[1];

  useEffect(() => {
    document.cookie = `${COOKIE_NAME}=${currentEnv};path=/`;
  }, []);

  const handleClickEnv = () => {
    const envIndex = ENV_LIST.findIndex((env) => env === currentEnv);
    const newEnv = ENV_LIST[(envIndex + 1) % ENV_LIST.length];
    // Sets new env cookie
    document.cookie = `${COOKIE_NAME}=${newEnv};path=/`;
    // Clears local storage i.e. token and refreshToken
    window.localStorage.clear();
    // reload the page
    window.location.reload();
    // force navigate to '/' to remove the referrer state to prevent bugs
    window.location.replace('/');
  };

  if (!ENV_LIST.includes(process.env.REACT_APP_DEPLOY_ENV)) {
    return null;
  }

  return (
    <Portal>
      <Button
        type="button"
        tabIndex={0}
        onDoubleClick={handleClickEnv}
        side={side || 'right'}
        bottom={bottom || '10px'}
      >
        <Box display="flex" height="100%" width="100%">
          <Box height="100%" margin="auto 5px 0px 0px">
            <Gear height={20} width={20} />
          </Box>
          <Box overflow="auto" height="100%" width="100%">
            <Text fontSize="14px" lineHeight="20px">
              Current Env:
              <strong>
                {` ${currentEnv.toUpperCase()}`}
              </strong>
            </Text>
          </Box>
        </Box>
      </Button>
    </Portal>
  );
};

export default EnvironmentSwitcher;
